import { Component, OnInit } from '@angular/core';
import { Options, LabelType } from 'ng5-slider';
import { FormBuilder, FormArray, FormControl, FormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router, ActivatedRoute } from '@angular/router';
import { Inject, Injectable } from '@angular/core';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';

import { DataServiceService } from '../../../services/data/data-service.service';
import { PdfmakerService } from '../../../services/pdfMaker/pdfmaker.service';


declare let gtag: Function;


@Component({
  selector: 'app-pricing-exemple',
  templateUrl: './pricing-exemple.component.html',
  styleUrls: ['./pricing-exemple.component.scss']
})
export class PricingExempleComponent implements OnInit {
  orgType: number;
  prechecked: boolean = false;

  CRFstate = true;
  HostingState = false;
  CodingState = false;
  SummaryState = false;
  currentPage = 'CRFstate'
  currentState = 'Basic'; // Compare if this.name changed
  price: string;

  state: Number = 0;

  userPrice = 0;
  totalPrice = 0;
  initialPrice = 0;
  hostingTotalPrice = 0;
  techSupportTotalPrice = 0;
  monthHosting = 0;
  monthSupport = 0;
  monthHostingSupport = 0;
  hostingSupportTotalPrice = 0;
  userTotalPrice = 0;
  patientTotalPrice = 0;

  nbMonthPayment: number = 3;

  nbMonthHosting: number = 3;

  serviceDuration: number;


  autoQuerriesPrice = 0;
  patientPrice = 0;
  crfVersionsPrice = 0;
  alertsPrice = 0;
  hostingPrice = 0;
  techSupportPrice = 0;
  serverPrice = 150;
  uploadPrice = 0;
  uploadPriceMonth = 0;
  uploadTotalPriceMth = 0

  exportPrice = 0;
  metricsPrice = 0;
  designPrice = 0;
  changePrice = 0;
  signOffPrice = 0;
  codingSysPrice = 0;
  adjudicationPrice = 0;

  pricingForm: FormGroup;

  Option9: any;
  option9: Options;

  constructor(
    @Inject(SESSION_STORAGE) private storage: StorageService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private dataService: DataServiceService,
    private pdfMakerService: PdfmakerService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
        this.orgType = params.o;
        if (this.orgType == 1) {
          this.prechecked = true;
        } else {
          this.prechecked = false;
        }
        // VALUE OF EACH INPUT
        this.pricingForm = this.fb.group({
          users: ['100'],
          crfVersions: ['1'],
          patients: ['5000'],
          autoQuerries: ['0'],
          export: this.fb.array(['CSV', 'SAS', 'Web-Custom']),
          metrics: this.prechecked == true ? this.fb.array(['MS Excel (.xlsx)', 'Web visual charts', 'PDF']) : this.fb.array(['MS Excel (.xlsx)']),
          codingSys: this.fb.array([]),
          upload: ['0'],
          adjudication: this.fb.array([]),
          hosting: ['3'],
          server: ['1'],
          monitoring: this.fb.array([]),
          signOff: this.prechecked == true ? this.fb.array(['per patient', 'per module/visit', 'per page of module/visit']) : this.fb.array(['per patient']),
          alerts: ['0'],
          changeReasons: this.fb.array(['Change Reasons']),
          design: this.fb.array([]),
        });

        // SERVER SLIDER
        this.Option9 = ['Mutualized', 'Dedicated'];
        this.option9 = {
          floor: 1,
          ceil: 2,
          disabled: this.prechecked,
          showTicksValues: true,
          showSelectionBar: true,
          showTicks: true,
          translate: (value: number, label: LabelType): string => {
            switch (label) {
              case LabelType.Floor:
                return 'Mutualized';
              case LabelType.Ceil:
                return 'Dedicated';
              default:
                if (value === 1) {
                  return 'Mutualized';
                } else if (value === 2) {
                  return 'Dedicated'
                }
            }
          }
        };



      });

  }


  // USERS SLIDERS OPTIONS
  option1: Options = {
    floor: 100,
    ceil: 1000,
    showTicksValues: true,
    ticksArray: [250, 500, 750, 1000],
    showSelectionBar: true,

    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Ceil: {
          return '1000';
        }
        case LabelType.Floor: {
          return 'Up to 100';
        }
        default: {
          if (value == 100) {
            return 'Up to 100';
          }
          return value + '';
        }
      }
    }
  };

  // PATIENTS SLIDERS OPTIONS
  option2: Options = {
    floor: 5000,
    ceil: 300000,
    showTicksValues: true,
    showSelectionBar: true,
    ticksArray: [25000, 100000, 200000, 300000],
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Ceil: {
          return '300000';
        }
        case LabelType.Floor: {
          return 'Up to 5000';
        }

        default: {
          if (value == 5000) {
            return 'Up to 5000';
          }
          return value + '';
        }
      }
    }
  };

  // CRF VERSIONS SLIDERS OPTIONS
  option3: Options = {
    floor: 1,
    ceil: 20,
    showSelectionBar: true,
    showTicksValues: true,
    ticksArray: [2, 5, 10, 20]
  };

  // Automatic querries SLIDERS OPTIONS
  option7: Options = {
    floor: 0,
    ceil: 1500,
    showTicksValues: true,
    showSelectionBar: true,
    ticksArray: [50, 100, 250, 500, 750, 1500],
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Ceil: {
          return '1500';
        }
        case LabelType.Floor: {
          return '0';
        }
        default: {
          if (value > 1500) {
            return '1500';
          }
          return value + '';
        }
      }
    }
  };


  // HOSTING SLIDER
  //valueOption4 = ['Mutualized', 'Dedicated', 'HADS(HIIPA)'];
  option4: Options = {
    floor: 3,
    ceil: 120,
    showTicksValues: true,
    showSelectionBar: true,
    ticksArray: [15, 30, 50, 85, 120],
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Ceil: {
          return '120';
        }
        case LabelType.Floor: {
          return '0';
        }
        default: {
          if (value > 120) {
            return '120';
          }
          return value + '';
        }
      }
    }
  };

  // TECHNICAL SUPPORT SLIDER
  /* option5: Options = {
    floor: 3,
    ceil: 120,
    showTicksValues: true,
    showSelectionBar: true,
    ticksArray: [15, 30, 50, 85, 120],
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Ceil: {
          return '120';
        }
        case LabelType.Floor: {
          return '0';
        }
        default: {
          if (value > 120) {
            return '120';
          }
          return value + '';
        }
      }
    }
  }; */

  //  ALERTS SLIDER
  option6: Options = {
    // showTicksValues: true,
    // showSelectionBar: true,
    floor: 0,
    ceil: 100,
    showTicksValues: true,
    showSelectionBar: true,
    ticksArray: [25, 50, 75, 100],
    // showTicks: true,
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Floor:
          return '0';
        case LabelType.Ceil:
          return '100';
        default: {
          return value + '';
        }
      }
    }
  };

  // Upload & Deidentification
  option8: Options = {
    floor: 0,
    ceil: 50,
    showTicksValues: true,
    showSelectionBar: true,
    ticksArray: [10, 20, 30, 40, 50],
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Ceil: {
          return '50';
        }
        case LabelType.Floor: {
          return '0';
        }
        default: {
          if (value > 50) {
            return '50';
          }
          return value + '';
        }
      }
    }
  };


  // TOGGLES VALUES
  //to disabled and decrease price
  Export: Array<any> = [
    { name: 'CSV', value: 'CSV', checked: true, formatName: 'CSV' },
    { name: 'SAS', value: 'SAS', checked: true, formatName: 'sas' },
    { name: 'Web-Custom', value: 'Web-Custom', checked: true, formatName: 'Web-Custom' },
  ];

  Metrics: Array<any> = [
    { name: 'MS Excel (.xlsx)', value: 'MS Excel (.xlsx)', checked: true, formatName: 'MS Excel (.xlsx)' },
    { name: 'Web visual charts', value: 'Web visual charts', checked: false, formatName: 'Web visual charts' },
    { name: 'PDF', value: 'PDF', checked: false, formatName: 'PDF' }
  ];

  CodingSys: Array<any> = [
    { name: 'MedDRA', value: 'MedDRA', checked: false, formatName: 'MedDRA' },
    { name: 'WHODrug', value: 'WHODrug', checked: false, formatName: 'WHODrug' }
  ];

  Upload: Array<any> = [
    { name: 'PDF', value: 'PDF', checked: false, formatName: 'PDF' },
    { name: 'DICOM', value: 'DICOM', checked: false, formatName: 'DICOM' },
    { name: 'Images', value: 'Images', checked: false, formatName: 'Images' },
    { name: 'Text Files', value: 'Text Files', checked: false, formatName: 'Text Files' }
    /* { name: 'Upload & Deidentification', value: 'yes', checked: false, formatName: 'Web Charts' }, */
  ];

  Adjudication: Array<any> = [
    { name: 'Adjudication module', value: 'Adjudication module', checked: false, formatName: 'Adjudication module' },
    { name: 'Corelab module', value: 'Corelab module', checked: false, formatName: 'Corelab module' },
    { name: 'Randomisation (IWRS) module', value: 'Randomisation (IWRS) module', checked: false, formatName: 'Randomisation (IWRS) module' }
  ];

  SignOff: Array<any> = [
    { name: 'per patient', value: 'per patient', checked: true, formatName: 'per patient' },
    { name: 'per module/visit', value: 'per module/visit', checked: false, formatName: 'per module/visit' },
    { name: 'per page of module/visit', value: 'per page of module/visit', checked: false, formatName: 'per page of module/visit' }
  ];

  Monitoring: Array<any> = [
    { name: 'Monitoring & Data Managment', value: 'Yes', checked: false, formatName: 'Web Charts' }
  ];

  ChangeReasons: Array<any> = [
    { name: 'Change Reasons', value: 'Change Reasons', checked: true, formatName: 'Web Charts' }
  ];

  Design: Array<any> = [
    { name: 'CRF design, mockups, review and validation by experts', value: 'Design', checked: false, formatName: 'Web Charts' }
  ];





  // Push checkbox values in the appropriate array of pricingForm
  onCheckboxChange(e, keyPf: string) {
    // keyPF (key PricingForm)
    const object = this[keyPf[0].toUpperCase() + keyPf.slice(1)];
    object.map(element => {
      if (element.value === e.source.name) {
        element.checked = !element.checked;
      }
    });
    const checkArray: FormArray = this.pricingForm.get(keyPf) as FormArray;
    if (e.checked) {
      checkArray.push(new FormControl(e.source.name));
    } else {
      let i = 0;
      checkArray.controls.forEach((item: FormControl) => {
        if (item.value === e.source.name) {
          checkArray.removeAt(i);
          return;
        }
        i++;
      });
    }
    this.checkForm(); // Check after pushing
  }



  selectPart(e, item) {
    const array = ['CRFstate', 'HostingState', 'CodingState', 'SummaryState'];
    this[item] = true;
    this.currentPage = item;
    array.forEach(element => {
      if (element != item) {
        this[element] = false;
      }
    });
    this.pricingForm.updateValueAndValidity();
  }


  // checkForm change variable this.name and this.price
  checkForm() {
    const form = this.pricingForm.value;

    this.nbMonthHosting = form.hosting;

    this.serviceDuration = Number(form.hosting) + 3;

    //Server + Hosting & Maintenance + Tech & Support
    if (form.hosting > 0) {
      if (form.server == 1) {
        this.hostingPrice = 150;
        this.hostingTotalPrice = 150 * form.hosting;
      }
      if (form.server == 2) {
        this.hostingPrice = 500;
        this.hostingTotalPrice = 500 * form.hosting;
      }
      this.techSupportPrice = 250;
      this.techSupportTotalPrice = 250 * form.hosting;
    } else {
      this.hostingPrice = 0;
      this.hostingTotalPrice = 0;
      this.techSupportPrice = 0;
      this.techSupportTotalPrice = 0;
    }

    // BASELINE SUPPORT = 250
    // DEDICATED HOSTING = 500
    // MUTUALIZED HOSTING = 150

    //Users
    if (form.users > 0) {
      //250 *30% = +75€/mois tous les 100 utilisateurs pour le support
      this.userPrice = Math.floor((form.users / 100)) * ((250 * 30) / 100);
      this.userTotalPrice = this.userPrice * form.hosting;
      if (this.orgType == 1) {
        this.userPrice = this.userPrice / 2;
        this.userTotalPrice = this.userTotalPrice / 2;
      }
    } else {
      this.userPrice = 0;
      this.userTotalPrice = 0;
    }


    //Patients
    if (form.patients > 0) {
      //mutualize hosting: 150 *30% = +45€ tous les 5000 patients pour l'hébergement
      //dedicated hosting: 500 *30% = +150 tous les 5000 patients pour l'hébergement
      //250 *30% = +75€ tous les 5000 patients pour le support
      if (form.server == 1) {
        this.patientPrice = (Math.floor((form.patients / 5000)) * ((250 * 30) / 100)) + (Math.floor((form.patients / 5000)) * ((150 * 30) / 100));
        this.patientTotalPrice = this.patientPrice * form.hosting;
      }
      if (form.server == 2) {
        this.patientPrice = (Math.floor((form.patients / 5000)) * ((250 * 30) / 100)) + (Math.floor((form.patients / 5000)) * ((500 * 30) / 100));
        this.patientTotalPrice = this.patientPrice * form.hosting;
      }
      if (this.orgType == 1) {
        //demi-tarif
        this.patientPrice = this.patientPrice / 2;
        this.patientTotalPrice = this.patientTotalPrice / 2;
      }
    } else {
      this.patientPrice = 0;
      this.patientTotalPrice = 0
    }


    // CRF Versions
    if (form.crfVersions > 0) {
      // +1500 par unité
      this.crfVersionsPrice = form.crfVersions * 1500;
    }

    //Automatic Querries
    if (form.autoQuerries > 0) {
      // +75 par unité
      this.autoQuerriesPrice = form.autoQuerries * 75;
      if (this.orgType == 1) {
        //-50% sur le 50 Premières quereies
        let reduc = (50 * 75) / 2;
        this.autoQuerriesPrice = this.autoQuerriesPrice - reduc;
      }
    } else {
      this.autoQuerriesPrice = 0;
    }


    //Alerts
    if (form.alerts > 0) {
      // +150 par unité
      this.alertsPrice = form.alerts * 150;
    } else {
      this.alertsPrice = 0;
    }


    //Upload & Deidentification
    if (form.hosting > 0) {
      // EDClin price = +(850*3) one-shot
      // Hosting = 
      if (form.upload > 0) {
        this.uploadPriceMonth = 25 * form.upload;
        this.uploadTotalPriceMth = 25 * form.upload * form.hosting;
        this.uploadPrice = 850 * 3;
      }
      if (form.upload === 0) {
        this.uploadPriceMonth = 0;
        this.uploadPrice = 0;
        this.uploadTotalPriceMth = 0;
      }
    }

    //Export
    this.exportPrice = 0;
    if (form.export.length > 0) {
      if (this.orgType == 1) {
        this.exportPrice = 0;
      }
      if (this.orgType == 2) {
        this.exportPrice = 1155;
      }
    } else {
      this.exportPrice = 0;
    }

    //Metrics
    this.metricsPrice = 0;
    if (form.metrics.length > 0) {
      if (this.orgType == 1) {
        this.metricsPrice = 0;
      }
      if (this.orgType == 2) {
        form.metrics.forEach(el => {
          if (el == 'Web visual charts') {
            this.metricsPrice += 850;
          }
          if (el == 'MS Excel (.xlsx)') {
            this.metricsPrice += 1700;
          }
          if (el == 'PDF') {
            this.metricsPrice += 1700;
          }
        });
      }
    } else {
      this.metricsPrice = 0;
    }

    //SignOff
    this.signOffPrice = 0;
    if (this.SignOff.length > 0) {
      if (this.orgType == 1) {
        this.signOffPrice = 0;
      }
      if (this.orgType == 2) {
        form.signOff.forEach(el => {
          if (el == 'per patient') {
            this.signOffPrice += 425;
          }
          if (el == 'per module/visit') {
            this.signOffPrice += 850;
          }
          if (el == 'per page of module/visit') {
            this.signOffPrice += 1700;
          }
        });
      }
    } else {
      this.signOffPrice = 0;
    }

    //CodingSys
    this.codingSysPrice = 0;
    if (form.codingSys.length > 0) {
      form.codingSys.forEach(el => {
        if (el == 'MedDRA') {
          this.codingSysPrice = form.codingSys.length * 3600;
        }
        if (el == 'WHODrug') {
          this.codingSysPrice = form.codingSys.length * 6000;
        }
      });
    } else {
      this.codingSysPrice = 0;
    }

    //Change Reasons
    this.changePrice = 0;
    if (form.changeReasons.length > 0) {
      //this.changePrice += 850;
      this.changePrice += 1970;
    } else {
      this.changePrice = 0;
    }

    //Design
    this.designPrice = 0;
    if (form.design.length > 0) {
      this.designPrice = 3000;
    } else {
      this.designPrice = 0;
    }

    //Adjucation (Additional modules)
    this.adjudicationPrice = 0;
    if (form.adjudication.length > 0) {
      form.adjudication.forEach(el => {
        if (el == 'Corelab module' || el == 'Adjudication module') {
          this.adjudicationPrice += 4250;
        }
        if (el == 'Randomisation (IWRS) module') {
          this.adjudicationPrice += 1700;
        }
      });
    } else {
      this.adjudicationPrice = 0;
    }

    this.updatePrice();
  }

  updatePrice() {
    //Private Cie fixPrice (base) by default : User = 75 / CRF = 1500 / Change reasons = 1970 / export = 1155 / Metrics excel = 1700 / Sign off per patient = 425 + 8770 => 15595€
    //Public fixPrice (base) by default : User = 37.5 / CRF = 1500 / Change reasons = 1970 / export = 0 / Metrics = 0 / Sign off = 0 + 8770 => 12277€
    let fixPrice = 8845  + this.autoQuerriesPrice  + this.alertsPrice + this.uploadPrice + this.crfVersionsPrice +
      this.codingSysPrice + this.adjudicationPrice + this.designPrice + this.exportPrice + this.metricsPrice +
      this.signOffPrice + this.changePrice;
    /* console.log(' this.userPrice ' + this.userPrice + ' this.autoQuerriesPrice ' + this.autoQuerriesPrice + ' this.patientPrice ' + this.patientPrice +
      ' this.alertsPrice ' + this.alertsPrice + ' this.uploadPrice ' + this.uploadPrice + ' this.crfVersionsPrice ' + this.crfVersionsPrice +
      ' this.codingSysPrice ' + this.codingSysPrice + ' this.adjudicationPrice ' + this.adjudicationPrice + ' this.designPrice ' + this.designPrice
      + ' this.exportPrice ' + this.exportPrice + ' this.metricsPrice ' + this.metricsPrice + ' this.signOffPrice ' + this.signOffPrice + ' this.changePrice ' + this.changePrice);  */

    this.monthHosting = this.hostingPrice + this.uploadPriceMonth;
    this.monthSupport = this.techSupportPrice;
    this.monthHostingSupport = this.monthHosting + this.monthSupport + this.userPrice + this.patientPrice;

    /* console.log("user par mois " + this.userPrice);
    console.log("patient par mois " + this.patientPrice);
    console.log("user total " + this.userTotalPrice);
    console.log("patient total " + this.patientTotalPrice);

    console.log("hosting par mois " + this.monthHosting);
    console.log("hosting total " + this.hostingTotalPrice);
    console.log("support par mois " + this.monthSupport);
    console.log("support total " + this.techSupportTotalPrice);
    console.log("upload par mois " + this.uploadPriceMonth);
    console.log("upload total " + this.uploadTotalPriceMth); */

    this.hostingSupportTotalPrice = this.hostingTotalPrice + this.techSupportTotalPrice + this.uploadTotalPriceMth + this.userTotalPrice + this.patientTotalPrice;

    //Private Cie totalPrice by default : Hosting = 3*150 = 450 / Support = 3*250 = 750 / fixPrice = 15595 => 16795€
    //Public totalPrice by default : Hosting = 3*150 = 450 / Support = 3*250 = 750 / fixPrice = 12277 => 13478€
    this.totalPrice = fixPrice + this.hostingSupportTotalPrice;
    /* console.log(' this.fixPrice ' + fixPrice + ' this.hostingTotalPrice ' + this.hostingTotalPrice + ' this.techSupportTotalPrice ' + this.techSupportTotalPrice); */

    this.initialPrice = fixPrice;


    if (this.totalPrice >= 100000) {
      this.nbMonthPayment = 6;
    } else {
      this.nbMonthPayment = 3;
    }



  }

  generatePdf() {
    /** spinner starts on init */
    this.spinner.show();
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide();
    }, 1000);
    this.pdfMakerService.sendValue(this.pricingForm.getRawValue(), this.totalPrice, this.initialPrice, this.monthHostingSupport, this.hostingSupportTotalPrice, this.nbMonthHosting);
    gtag('config', 'UA-135464323-1', { 'page_path': 'PDF' });
  }

  // Send Form values on submit to data-service
  onSubmit() {
    this.dataService.sendValue(this.pricingForm.getRawValue());
    this.dataService.sendInfo(this.totalPrice.toString(), this.initialPrice.toString(), this.monthHostingSupport.toString(),
      this.hostingSupportTotalPrice.toString(), this.nbMonthHosting.toString(), this.nbMonthPayment.toString());
    this.router.navigate(['/contact/contact-form'], { queryParams: { o: this.orgType } });
    this.storage.set('pricingForm', this.pricingForm.getRawValue())
  }



}
